import React from "react";

interface AdvancedToggleButtonProps {
  onClick: () => void;
  label: string;
  isHide?: boolean;
}

const AdvancedToggleButton: React.FC<AdvancedToggleButtonProps> = ({
  onClick,
  label,
  isHide = false,
}) => {
  return (
    <button
      className="bg-transparent shadow-none border-none cursor-pointer underline"
      onClick={onClick}
    >
      [{label}]
    </button>
  );
};

export default AdvancedToggleButton;
;
